import React, { Component, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { BasicPage } from "../components/BasicPage";

import {
    Grid, Container, Stack, Typography,
    Alert, Button, TextField, Link, Box, Card, CardContent, IconButton
} from '@mui/material/'

import { sendEmailTemplate } from "../firebase";
import { firebaseConfig } from "../firebase";

import {
    FormContainer, TextFieldElement, PasswordRepeatElement,
    CheckboxElement, PasswordElement, useForm, useFormContext
} from 'react-hook-form-mui'

//import {} from 'react-hook-form'
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import Close from '@mui/icons-material/Close';

import { useAuth } from "../hooks/useAuth";
import { FieldsContact, ResetFormButton } from '../components/FormFields';
import { FadingAlert } from '../components/FormFields';
import dayjs from 'dayjs';

export const OrderService = () => {

    const { user, claims, accountID } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [showWebshopCard, setShowWebshopCard] = useState(true);
    const [isPunchoutUser, setIsPunchoutUser] = useState(false);

    const [submittedData, setSubmittedData] = useState(false);
    const formContext = useForm();
    const { reset, formState } = formContext;

    // Check if user is in a punchout session - redirect to punchout page
    useEffect(() => {
        const punchoutSessionId = sessionStorage.getItem('punchoutSessionId');
        if (punchoutSessionId) {
            setIsPunchoutUser(true);
            // Redirect punchout users to punchout shopping page
            const punchoutType = sessionStorage.getItem('punchoutType') || 'cxml';
            navigate(`/web/punchout?sessionId=${punchoutSessionId}&punchoutType=${punchoutType}`);
        }
    }, [navigate]);

    useEffect(() => {
        console.log("formState.isSubmitSuccessful", formState.isSubmitSuccessful);

        if (formState.isSubmitSuccessful) {
            reset({});

        }
    }, [formState.isSubmitSuccessful, submittedData, reset]);



    const onSubmit = (formData) => {

        setSubmittedData(formData);
        setError("");
        setSuccess("");

        var data = {};
        data.form = {};
        data.user = {};

        if (!accountID) {
            setError("Bitte wählen Sie einen Account aus.");
            return;
        }

        if (!formData.author && !formData.title && !formData.ISBN && !formData.publisher) {
            setError("Die Felder enthalten keine Daten. Bitte füllen Sie mindestens ein Feld aus.");
            return;
        }

        data.template = "orderForm";
        data.form.accountID = accountID;
        data.form.orderDate = new Date().toLocaleDateString();
        data.form.orderTime = new Date().toLocaleTimeString();

        Object.assign(data.form, formData);
        Object.assign(data.user, claims);

        sendEmailTemplate(data);
        setSuccess("Ihre Bestellung wurde erfolgreich versendet.");
    }


    // Show loading while redirecting punchout users
    if (isPunchoutUser) {
        return (
            <BasicPage title="Bestell-Service" icon={<ShoppingCart />}>
                <Alert severity="info" sx={{ m: 2 }}>
                    Punchout-Benutzer werden zum Punchout-Warenkorb weitergeleitet...
                </Alert>
            </BasicPage>
        );
    }

    return (
        <BasicPage title="Bestell-Service" icon={<ShoppingCart />}>

            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                sx={{ width: '100%' }}
            >
                <FormContainer
                    defaultValues={{ name: '' }}
                    formContext={formContext}
                    onSuccess={(data) => {
                        setSubmittedData(data);
                        onSubmit(data);
                    }}
                >
                    <Stack spacing={2}
                        sx={{
                            width: {
                                xs: '100%',
                                sm: '500px'
                            },
                            margin: '0 auto',
                            padding: 2,
                        }}  
                    >
                        {/* Webshop Links - At the very top */}
                        {firebaseConfig.projectId === 'litport-schoeningh' && (
                            <Card sx={{ mt: 2, mb: 2, bgcolor: '#f5f5f5', color: 'text.primary' }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        🛒 Web-Shops
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 2 }}>
                                        Entdecken Sie unser vollständiges Sortiment in unseren Web-Shops
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            href="https://fachmedien.schoeningh-buch.de/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Bücher & eBooks
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            href="https://www.meine-datenbanken.de/datenbank-finder?mandant=K124671"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            juristische Datenbanken
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        )}

                        <Typography component="h2" variant="h5">
                            Kontakt
                        </Typography>

                        <span>Bitte ausfüllen, soweit Daten bekannt</span>

                        <FieldsContact></FieldsContact>

                        <Typography component="h2" variant="h5">
                            Bestellung
                        </Typography>
                        <span>Bitte ausfüllen, soweit Daten bekannt</span>

                        <TextFieldElement
                            size="small"
                            label={'Autor'}
                            name={'author'}
                        />

                        <TextFieldElement
                            size="small"
                            label={'Titel'}
                            name={'title'}
                        />

                        <TextFieldElement
                            size="small"
                            label={'ISBN'}
                            name={'ISBN'}
                        />

                        <TextFieldElement
                            size="small"
                            label={'Verlag'}
                            name={'publisher'}
                        />


                        <TextFieldElement
                            label={'Freitext'}
                            name={'messageOrder'}
                            placeholder="Ihre Nachricht"
                            multiline
                            rows={4}

                        />

                        {error && <Alert severity="error">{error}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}

                        <Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            size="large"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Bestellung absenden
                        </Button>

                        <ResetFormButton></ResetFormButton>

                    </Stack>
                </FormContainer>
            </Grid>

        </BasicPage >

    );
}

